import { createContext } from 'react';
import { createContextualCan } from '@casl/react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const AbilityContext = createContext<any>({});

const { Consumer } = AbilityContext;

export const Can = createContextualCan(Consumer);
